var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Usunąć promocję "+_vm._s(_vm.promotionType)+_vm._s(_vm.promotionName)+"?")]),_c('button',{staticClass:"btn btn-red",on:{"click":_vm.deletePromotion}},[_vm._v("Usuń")])])}
var staticRenderFns = []

export { render, staticRenderFns }